import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import paymentDetailsAPI from '../../sources/api/paymentDetailsAPI';

// constants
import { PAYMENT_DETAILS_FETCH } from '../../constants/paymentDetailsTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { paymentDetailsSchema } from '../../schemas/Normalizr';

export function* paymentDetailsFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(PAYMENT_DETAILS_FETCH, call(paymentDetailsAPI.fetch, params), paymentDetailsSchema);
  } catch (e) {
    yield put(error(PAYMENT_DETAILS_FETCH, e));
  } finally {
    yield put(doneIndicator(PAYMENT_DETAILS_FETCH));
  }
}

export function* watchPaymentDetailsFetch() {
  yield takeEvery(PAYMENT_DETAILS_FETCH, paymentDetailsFetch);
}

export default function* root() {
  yield all([
    fork(watchPaymentDetailsFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/paymentDetails/paymentDetailsFetch.js